// @helpers
const { APIGet } = require('utilities/APIRequestHelper');

// @constants
const {
    BROKER_ATTETION_PLAN_MODAL_CLOSE_AND_REMEMBER,
    BROKER_ATTETION_PLAN_MODAL_CLOSE,
    BROKER_ATTETION_PLAN_MODAL_GET_DATES_SUCCESS,
    BROKER_ATTETION_PLAN_MODAL_INIT
} = require('constants/actionTypes');

const closeAndRemember = () => ({
    type: BROKER_ATTETION_PLAN_MODAL_CLOSE_AND_REMEMBER,
    payload: {}
});

const closeModal = () => ({
    type: BROKER_ATTETION_PLAN_MODAL_CLOSE,
    payload: {}
});

const getFiscalDatesSuccess = (data) => ({
    type: BROKER_ATTETION_PLAN_MODAL_GET_DATES_SUCCESS,
    payload: {
        data
    }
});

const getFiscalDates = () => (dispatch) => {
    return APIGet({
        dispatch,
        endpoint: 'pensionPlanFiscalInfo',
    })
    .then(response => dispatch(getFiscalDatesSuccess(response)))
}

const initSuccess = (userName, place) => ({
    type:BROKER_ATTETION_PLAN_MODAL_INIT,
    payload: {
        userName,
        place
    }
});

const init = (userName, place) => (dispatch) => {
    dispatch(getFiscalDates())
        .then(() => {
            dispatch(initSuccess(userName, place))
        });
}

module.exports = {
    init,
    closeAndRemember,
    closeModal
};
